import { makeRequest } from '../../../utils/REST';

export function createGroupWithPool(payload) {
    return makeRequest(
        'POST',
        `${window.config.baseAPIPath}/sport/spilklub/big9/pool/draft`,
        payload
    );
}

export function postCreateGroup(payload) {
    return makeRequest(
        'POST',
        `${window.config.baseAPIPath}/sport/spilklub/big9/group/create`,
        payload
    );
}

export function fetchGroups({ pageSize, pageNumber, type }) {
    return makeRequest(
        'GET',
        `${window.config.baseAPIPath}/sport/spilklub/big9/groups`,
        {
            pageSize,
            pageNumber,
            type,
        }
    );
}

export function postCreatePool(payload) {
    return makeRequest(
        'POST',
        `${window.config.baseAPIPath}/sport/spilklub/big9/pool/create`,
        payload
    );
}

export function fetchOpenPools() {
    return makeRequest(
        'GET',
        `${window.config.baseAPIPath}/sport/spilklub/big9/experts`,
        {}
    );
}

export function fetchPools({ groupId }) {
    return makeRequest(
        'GET',
        `${window.config.baseAPIPath}/sport/spilklub/big9/group/pools`,
        {
            groupId,
        }
    );
}

export function fetchPoolById({ poolId }) {
    return makeRequest(
        'GET',
        `${window.config.baseAPIPath}/sport/spilklub/big9/pool/id`,
        {
            poolId,
        }
    );
}

export function fetchPoolByHash({ poolHash }) {
    return makeRequest(
        'GET',
        `${window.config.baseAPIPath}/sport/spilklub/big9/pool/hash`,
        {
            hash: poolHash,
        }
    );
}

export function postAddCoupon(payload) {
    return makeRequest(
        'POST',
        `${window.config.baseAPIPath}/sport/spilklub/big9/coupon/add`,
        payload
    );
}

export function updateCoupon(payload) {
    return makeRequest(
        'POST',
        `${window.config.baseAPIPath}/sport/spilklub/big9/coupon/update`,
        payload
    );
}

export function buyCoupon(payload) {
    return makeRequest(
        'POST',
        `${window.config.baseAPIPath}/sport/spilklub/big9/coupon/buy`,
        payload
    );
}

export function updateGroup({
    groupId,
    groupName,
    description,
    avatarUrl,
    groupOwnerId,
    sharePrice,
    sharesLimit,
    deadlineTime,
    isPublic,
}) {
    return makeRequest(
        'PUT',
        `${window.config.baseAPIPath}/sport/spilklub/big9/group/update`,
        {
            groupId,
            groupName,
            description,
            avatarUrl,
            groupOwnerId,
            sharePrice,
            sharesLimit,
            deadlineTime,
            public: isPublic,
        }
    );
}

export function buyShares(payload) {
    return makeRequest(
        'POST',
        `${window.config.baseAPIPath}/sport/spilklub/big9/share/buy`,
        payload
    );
}
